import get from 'lodash/get';

export const mapFormToUserGroup = values => ({
  ...values,
  apps: (values.communityApps || []).map(ca => {
    const splittedApp = ca.app?.split('_');
    const installationTag = get(splittedApp, '[0]');
    const communityTag = get(splittedApp, '[1]');

    return {
      installationTag,
      communityTag,
      features: (ca.features || []).map(f => ({
        tag: f.feature,
        roles: f.roles,
      })),
    };
  }),
});
